/**
 * @description 菜单状态管理
 * @author xiehan
 * @date 2018/9/19
 */
import MenuBiz from '../logic/leftMenuBiz'

export default {
  state: {
    menuList: [],
    filterMenuList: [],
    defaultOpenMenu: [],
    defaultActiveMenu: ''
  },
  getters: {
    findMenuByName: (state) => (name) => {
      return state.menuList.find(item => item.name === name)
    },
    findMenuByCode: (state) => (code) => {
      return state.menuList.find(item => item.code === code)
    },
    filterMenuByLevel: (state) => (level) => {
      let menu = state.menuList.filter(item => item.type === 'MENU' && item.inPage && item.level === level)
      return menu.sort((a, b) => a.sortIndex - b.sortIndex)
    }
  },
  mutations: {
    getMenuLength(state, obj) {
      obj.length = state.menuList.length
    },
    setMenuList(state, list) {
      // 设置权限 参考./plugins/rac.js
      this.commit('gSetPermissions', list)
      state.menuList = list
      state.filterMenuList = list
    },
    // 设置默认激活菜单
    setActiveMenu(state, code) {
      let name = state.menuList.find(item => item.code === code).name
      state.defaultActiveMenu = name
    },
    // 设置一级菜单
    handlerMenuLevel1(state) {
      state.filterMenuList = state.menuList.filter(item => item.type === 'MENU' && item.inPage && item.level === '1')
      state.filterMenuList.sort((a, b) => a.sortIndex - b.sortIndex)
      this.commit('handlerMenuLevel2', {
        menuList: state.filterMenuList,
        level: '2'
      })
    },
    // 设置二级菜单
    handlerMenuLevel2(state, info) {
      if (info.menuList.length === 0) return
      info.menuList.map((parentItem) => {
        state.defaultOpenMenu.push(parentItem.name)
        parentItem.childMenu = state.menuList.filter(
          item => item.type === 'MENU' &&
            item.inPage &&
            item.level === info.level &&
            item.parentID === parentItem.id
        )
        parentItem.childMenu.sort((a, b) => a.sortIndex - b.sortIndex)
        if (info.level === '2') {
          // 设置三级菜单
          this.commit('handlerMenuLevel2', {
            menuList: parentItem.childMenu,
            level: '3'
          })
        }
      })
      state.defaultOpenMenu = [...new Set(state.defaultOpenMenu)];
    }
  },
  actions: {
    setMenuList({ commit }) {
      return new Promise(function (res, rej) {
        let lengthObj = {}
        commit('getMenuLength', lengthObj)
        if (!lengthObj.length) {
          MenuBiz.getMenuAndButton().then((data) => {
            commit('setMenuList', data)
            commit('handlerMenuLevel1');
            res(data)
          })
        } else {
          res()
        }
      })
    }
  }
}
